/* eslint-disable max-len */
import RestService from '../services/rest';

async function getUsers(limit, skip, clientId, search = '', type = '', status = '', order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/users?limit=${limit}&skip=${skip}&clientId=${clientId}&search=${search}&type=${type}&status=${status}&order=${order}&field=${field}`,
  );
}

async function getAllUsers(limit, skip, search = '', type = '', status = '', order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/users/all?limit=${limit}&skip=${skip}&search=${search}&type=${type}&status=${status}&order=${order}&field=${field}`,
  );
}

async function resendPassword(userId) {
  return RestService.putAuthenticated('panel/users/resend-password', { userId });
}

async function updateUsersPermission(
  clientId,
  userId,
  data,
  approveId1,
  approveId2,
  locationId,
  bu,
  deposit,
  deliveryCode,
  clientWithdraw,
  emailSeller,
) {
  return RestService.postAuthenticated(
    `panel/users/update?user=${userId}&client=${clientId}`,
    {
      data,
      approveId1,
      approveId2,
      locationId,
      bu,
      deposit,
      deliveryCode,
      clientWithdraw,
      emailSeller,
    },
  );
}

async function activeUser(id, status) {
  return RestService.putAuthenticated('panel/users/update', { id, status });
}

async function multiApprove(id, multi) {
  return RestService.putAuthenticated('panel/users/update', { id, multiApprove: multi });
}

async function updateUserClientStatus(clientId, userId, status) {
  return RestService.postAuthenticated(`panel/users/client/status?user=${userId}&client=${clientId}`,
    { status });
}

async function createUser(user) {
  return RestService.postAuthenticated('panel/users/create', user);
}

async function uploadCsvUsers(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/users/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function getCsvUsersModel() {
  const response = await RestService.getAuthenticated('panel/users/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Users CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvUsersReport() {
  const response = await RestService.getAuthenticated('panel/users/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'users-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getAccessLoginReport(data) {
  const {
    initialDate = null, finalDate = null, cnpj = null, corporateName = null, clientERPCode = null,
  } = data;

  return RestService.getAuthenticated(
    'panel/users/report/accessLogin'
    + `?initialDate=${initialDate}`
    + `&finalDate=${finalDate}`
    + `&cnpj=${cnpj}`
    + `&corporateName=${corporateName}`
    + `&clientERPCode=${clientERPCode}`,
    { responseType: 'blob' },
  );
}

async function getParamsNewUser(clientId, state) {
  return RestService.getAuthenticated(`panel/users/getParamsNewUser?clientId=${clientId}&stateUser=${state}`);
}

export default {
  getUsers,
  updateUsersPermission,
  activeUser,
  updateUserClientStatus,
  createUser,
  getCsvUsersModel,
  uploadCsvUsers,
  getAllUsers,
  resendPassword,
  getCsvUsersReport,
  getAccessLoginReport,
  multiApprove,
  getParamsNewUser,
};
